import React, { useState, useEffect, useCallback } from "react";
import images from "../../../constant/images";
import { Nav } from "../../../layouts/navbar/nav";
import Sidebar from "../../../layouts/sidebar/sidebar";
import axios from "axios";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function WelcomeTwo() {
  const { i18n, t } = useTranslation();
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };
  const language = localStorage.getItem("i18nextLng");

  const [user, setUser] = useState(null);
  const [membershipPack, setMembershipPack] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [canFetch, setCanFetch] = useState(false);
  const [isRequestLoading, setIsRequestLoading] = useState(false);
  const [error, setError] = useState(null);
  const location = useLocation();
  const { id, price, pack } = location.state;
  const navigate = useNavigate();

  const baseUrl = useSelector((state) => state.gtm.baseUrl);

  // Fetch user and membership pack data
  const fetchData = useCallback(async () => {
    try {
      const token = localStorage.getItem("userToken");
      if (token) {
        // Fetch user data
        const userResponse = await axios.get(`${baseUrl}/user`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        setUser(userResponse.data);

        if (id) {
          const packResponse = await axios.get(`${baseUrl}/packs/${id}`);
          setMembershipPack(packResponse.data.pack);
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setError(error);
    } finally {
      setIsLoading(false);
      setCanFetch(false);
    }
  }, [baseUrl, t]);

  // Check request for payment
  const checkRequest = async () => {
    try {
      setIsRequestLoading(true);
      const response = await axios.post(
        `${baseUrl}/check-request`,
        {
          user_id: user?.id,
          pack: membershipPack?.name,
        },
        {
          withCredentials: true,
          withXSRFToken: true,
          credentials: "include",
        }
      );
      if ((response.status = 200)) {
        navigate("/membership/paimentInfo", {
          state: {
            pack: pack,
            price: price,
          },
        });
      }
    } catch (error) {
      console.error("Error checking request:", error);
      setError(error);
    } finally {
      setIsRequestLoading(false);
    }
  };

  const free = async () => {
    try {
      setIsRequestLoading(true);
      const response = await axios.post(
        `${baseUrl}/free`,
        {
          user_id: user?.id,
        },
        {
          withCredentials: true,
          withXSRFToken: true,
          credentials: "include",
        }
      );

      if (response.status === 200) {
        navigate("/membership/felicitation", {
          state: {
            pack: pack?.name,
          },
        });
      }
    } catch (error) {
      const message = error.response?.data?.message;
      if (message?.includes("PUSH_TOO_MANY_EXPERIENCE_IDS")) {
        setError(error);
      } else {
        setError(error);
      }
    } finally {
      setIsRequestLoading(false);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      setCanFetch(true);
      setIsLoading(true);
    }, 1000);

    return () => {
      setError(null);
      setCanFetch(false);
      setIsLoading(true);
      setMembershipPack(null);
    };
  }, []);
  useEffect(() => {
    if (canFetch) {
      fetchData();
    }
  }, [canFetch, fetchData]);


  if (isLoading) {
    return (
      <div className="bg-white shadow-custom bg-opacity-[87%] h-full flex flex-col justify-center items-center p-6 md:p-16 gap-4 md:gap-8 w-full md:w-[100%] rounded-3xl py-8 md:py-12">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-gray-900"></div>
      </div>
    );
  }
  // if (isLoading) {
  //   return (
  //     <div
  //       className="loader h-[100vh] flex justify-center items-center"
  //       style={{
  //         backgroundImage: `url(${images.golf_field})`,
  //         backgroundPosition: "center",
  //         backgroundSize: "cover",
  //         backgroundRepeat: "no-repeat",
  //       }}
  //     >
  //       <div className="spinner"></div>
  //     </div>
  //   );
  // }

  if (error) {
    return (
      <div className="bg-white shadow-custom bg-opacity-[87%] h-full flex flex-col justify-center items-center p-6 md:p-16 gap-4 md:gap-8 w-full md:w-[100%] rounded-3xl py-8 md:py-12">
        <div className="text-center text-base md:text-xl">{error}</div>
      </div>
    );
  }

  return (
    <div className="bg-white shadow-custom bg-opacity-[87%] flex flex-col h-full justify-start pt-6 md:pt-10 lg:pt-20 items-center px-4 md:px-8 lg:px-16 xl:px-24 gap-4 md:gap-6 lg:gap-8 w-full rounded-3xl py-6 md:py-8 lg:py-12">
      <div className="text-center w-full text-lg md:text-xl lg:text-2xl xl:text-3xl font-bold mb-4 md:mb-6">
        <p>
        {language === "fr" ? (
            `✨ Bienvenue dans l'adhésion au ${membershipPack?.name}! ✨`
          ) : (
            `✨ Welcome to ${membershipPack?.name} membership! ✨`
          )}
        </p>
      </div>
      <div className="flex flex-col gap-3 md:gap-4 lg:gap-5 leading-relaxed md:leading-loose">
        <span className="text-base md:text-lg lg:text-xl">
          {language === "fr"
            ? `${membershipPack?.fr_description}`
            : `${membershipPack?.description}`}
        </span>
        {/* <span className="text-sm md:text-base">
                {t("membership_request.infos")} <strong>{membershipPack?.name}</strong>,{" "}
                {t("membership_request.infos2")}
                <ul className="list-disc ms-4 md:ms-8">
                  {membershipPack?.privileges?.map((privilege) => (
                    <li key={privilege.id} className="text-sm md:text-base">
                      {privilege.description}
                    </li>
                  ))}
                </ul>
              </span> */}
      </div>
      {membershipPack?.order === 1 ? (
        <button
          onClick={free}
          style={{
            backgroundImage: `url(${membershipPack?.background})`,
            backgroundColor: `${membershipPack?.color}`,
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
          }}
          className="text-white text-center shadow-button hover:opacity-70 font-bold text-base md:text-lg lg:text-xl xl:text-2xl p-2 md:p-3 w-full md:w-3/4 lg:w-1/2 rounded-xl mt-6 md:mt-8 lg:mt-10 xl:mt-12"
        >
          {isRequestLoading ? (
            <div className="flex justify-center">
              <div className="animate-spin rounded-full h-5 w-5 md:h-6 md:w-6 border-b-2 border-white"></div>
            </div>
          ) : (
            <h1>{language === "fr" ? "Procéder au paiement" : "Proceed to payment"}</h1>
          )}
        </button>
      ) : (
        <button
          onClick={checkRequest}
          style={{
            backgroundImage: `url(${membershipPack?.background})`,
            backgroundColor: `${membershipPack?.color}`,
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
          }}
          className="text-white text-center shadow-button hover:opacity-70 font-bold text-base md:text-lg lg:text-xl xl:text-2xl p-2 md:p-3 w-full md:w-3/4 lg:w-1/2 rounded-xl mt-6 md:mt-8 lg:mt-10 xl:mt-12"
        >
          {isRequestLoading
            ? t("twichiyat.loading")
            : language === "fr" ? "Procéder au paiement" : "Proceed to payment"}
        </button>
      )}

      {error && (
        <div className="text-red-500 mt-4 md:mt-5 font-bold text-center text-sm md:text-base">{error}</div>
      )}
    </div>
  );

  // if (error) {
  //   return (
  //     <div
  //       className="flex flex-col gap-12 min-h-screen"
  //       style={{
  //         backgroundImage: `url(${images.golf_field})`,
  //         backgroundPosition: "center",
  //         backgroundSize: "cover",
  //         backgroundRepeat: "no-repeat",
  //       }}
  //     >
  //       <Nav />
  //       <div className="flex justify-center mx-16 mb-20">
  //         <div className="flex w-full justify-between items-start">
  //           <Sidebar />
  //           <div className="bg-white shadow-custom bg-opacity-[87%] h-full flex flex-col justify-center items-center p-16 gap-8 w-[75%] rounded-3xl py-12">

  //             <div className="text-center text-xl">{error}</div>
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   );
  // }

  // return (
  //   <div
  //     className="flex flex-col gap-12 min-h-screen"
  //     style={{
  //       backgroundImage: `url(${images.golf_field})`,
  //       backgroundPosition: "center",
  //       backgroundSize: "cover",
  //       backgroundRepeat: "no-repeat",
  //     }}
  //   >
  //     <Nav />
  //     <div className="flex justify-center mx-16 mb-20">
  //       <div className="flex w-full justify-between items-start">
  //         <Sidebar />
  //         <div className="bg-white shadow-custom bg-opacity-[87%] flex flex-col h-full justify-start pt-20 items-center px-24 gap-8 w-[75%] rounded-3xl py-12">
  //           <div className="text-center text-3xl font-bold mb-6">
  //             <p>
  //               ✨ Bienvenue dans l'adhésion au Pack {membershipPack?.name}! ✨
  //             </p>
  //           </div>
  //           <div className="text-start flex flex-col gap-5 leading-loose">
  //             <span>{membershipPack?.description}</span>
  //             <span>
  //               En tant que membre {membershipPack?.name}, vous bénéficiez de :
  //               <ul className="list-disc ms-8">
  //                 {membershipPack?.privileges?.map((privilege) => (
  //                   <li key={privilege.id}>{privilege.description}</li>
  //                 ))}
  //               </ul>
  //             </span>
  //           </div>
  //           <button
  //             onClick={checkRequest}
  //             style={{
  //               backgroundImage: `url(${membershipPack?.background})`,
  //               backgroundPosition: "center",
  //               backgroundRepeat: "no-repeat",
  //               backgroundSize: "cover",
  //             }}
  //             className="text-black text-center shadow-button hover:opacity-70 font-bold text-2xl p-3 w-1/2 rounded-xl mt-24"
  //           >
  //             {isRequestLoading ? "Processing..." : "Procéder au paiement"}
  //           </button>
  //         </div>
  //       </div>
  //     </div>
  //   </div>
  // );
}